var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('div',{staticClass:"mindmap-container"},[_c('Toolbar'),_c('Edit',{ref:"editRef",attrs:{"org-data":_vm.caseTreeData},on:{"save":_vm.onSave}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }